import { useEffect } from 'react';
import DOMPurify from 'dompurify';
import StringToKebab from '../../helpers/StringToKebab';
import Cover, { CoverStyles } from './cover';
import LuckyNumberStyles, {LuckyNumberHostStyles} from '../LuckyNumberStyles';
import ImageList, { ImageListStyles } from './imageList';
import RaffleCalendar, { RaffleCalendarStyles } from './raffleCalendar';
import Winners, { WinnersStyles } from './winners';
import styled from 'styled-components';
import FaqSection, { FaqSectionStyles } from './faq';

const LuckyNumberPageSection = ({sectionData, promoData, order, openAgreement, openAcceptAgreement, openLuckyNumbers}) => {
    const LuckyNumberPageSectionContainer = styled.section`
        ${LuckyNumberHostStyles}
        ${LuckyNumberStyles}
        ${sectionData.recordTypeName === 'Cover' && CoverStyles}
        ${sectionData.recordTypeName === 'ImageList' && ImageListStyles}
        ${sectionData.recordTypeName === 'RaffleCalendar' && RaffleCalendarStyles}
        ${sectionData.recordTypeName === 'Winners' && WinnersStyles}
        ${sectionData.recordTypeName === 'FAQ' && FaqSectionStyles}
        ${sectionData.customCss && sectionData.customCss}
    `;

    useEffect(() => {
        console.log(sectionData.id, sectionData);
    },[sectionData]);

    return (
        <LuckyNumberPageSectionContainer id={StringToKebab(sectionData.title || '')} style={{order: order}}>
            {sectionData.recordTypeName === 'Cover' && <Cover sectionData={sectionData} promoData={promoData} openAcceptAgreement={openAcceptAgreement} openLuckyNumbers={openLuckyNumbers} />}
            {sectionData.recordTypeName === 'ImageList' && <ImageList sectionData={sectionData} promoData={promoData} />}
            {sectionData.recordTypeName === 'RaffleCalendar' && <RaffleCalendar sectionData={sectionData} promoData={promoData} />}
            {sectionData.recordTypeName === 'Winners' && <Winners sectionData={sectionData} promoData={promoData} />}
            {sectionData.recordTypeName === 'FAQ' && <FaqSection sectionData={sectionData} promoData={promoData} />}
            
            {sectionData.footnotes && <div className='luckyNumber__footnotes' dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(sectionData.footnotes)}} />}
        </LuckyNumberPageSectionContainer>
    );
}

export default LuckyNumberPageSection;